$(document).ready(function() {
    setTimeout(update_sharing_data, 2000);
});

function update_sharing_data(){
    var url = window.location.href.split('?')[0];
    if (url.includes('/free-event-planning-software-make-you-rockstar')){
        $('.st-total .st-label').text('3.5K');
    }else if(url.includes('/steps-create-event-marketing-plan')){
        $('.st-total .st-label').text('2.4K');
    }else if(url.includes('/guide-event-communication-strategy-plan-tools')){
        $('.st-total .st-label').text('1.8K');
    }else if(url.includes('/event-registration-software-price-comparison/')){
        $('.st-total .st-label').text('1.4K');
    }
    $('.st-total').css('visibility', 'visible');
    $('.st-total').removeClass('st-hidden');
}
